<template lang="html">
  <section class="nav-bar">
    <div class="hero-head">
    <nav class="navbar">
      <div class="navbar-brand">
        <a class="navbar-item" href="/search">
          <img src="../assets/logo_mobidata.png" alt="Logo">
        </a>
        <!--
    Using the v-on: directive to listen for the click event 
    and toggle the data property showNav. Also, using the v-bind: directive
     to reactively update the class attribute 'is-active' based on the showNav property.
    -->
        <div class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <!--
    Using the v-bind: directive to reactively update the class 
    attribute 'is-active' based on the showNav property.
    -->
      <div class="navbar-menu" :class="{ 'is-active': showNav }">
        <div class="navbar-end">
          <router-link v-if="isUserLogged" class="navbar-item" :to="{ path: '/search/saved' }">Sauvegardes</router-link>
          <router-link v-if="isUserLogged" class="navbar-item" :to="{ path: '/search' }">Données techniques</router-link>
          <router-link v-if="isUserLogged" class="navbar-item" :to="{ path: '/commons' }">Equivalences</router-link>
          <span class="space"></span>
          <a v-if="isUserLogged" class="navbar-item" v-on:click="signout()">Déconnexion</a>
          <router-link v-else class="navbar-item" :to="{ path: '/login' }">Login</router-link>
        </div>
      </div>
    </nav>
    </div>
  </section>

</template>

<script lang="js">
export default  {
  name: 'nav-bar',
  props: [],
  mounted() {
    // console.log(this.$route.name != "Login", this.$route.name == "404")
    var url = process.env.VUE_APP_API_URL+'me';
      this.axios.get(url,{
        headers: {'Authorization': sessionStorage.getItem('profile_token')}
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error)=>{     
           sessionStorage.removeItem('profile_token');
           if(this.$route.name != "Login" && sessionStorage.getItem('profile_token') == null){
            this.$router.push('/login') 
           }
        });
    
    console.log(this.$route);
  },
  data() {
    return {
      showNav:false,
    }
  },
  methods: {
    signout(){
      sessionStorage.removeItem('profile_token');
      sessionStorage.removeItem('email');
      location.reload();
    },
  },
  computed: {
    isUserLogged(){
      return sessionStorage.getItem('profile_token') != null
    }
  }
}
</script>

<style scoped lang="scss">
.nav-bar {
}

.space{
  width:60px;
  height:100%;
  // background-color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/nav-bar.vue